<template>
  <div class="map-container grey lighten-4" style="position: relative">
    <div id="map" ref="map" class="map"></div>
    <v-row
      justify="center"
      align="center"
      v-show="!mapHasLoaded"
      style="left: 50%; top: 45%; position: absolute"
    >
      <v-col justify="center" align="center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
        <p style="text-align: center">Laster kart</p>
      </v-col>
    </v-row>
    <map-geographic-filter />
    <map-drawing
      class="tegning"
      v-if="kartlastet"
      v-show="activeGeographicFilterMode === geographicFilterOptions[2]"
      @tegning:oppdatert="getAndSetExtent"
      :main-layer="hovedlag"
      :kartview="mapViewObject"
      :tegnelag="tegnelag"
    ></map-drawing>
    <map-buffer
      class="buffer"
      v-if="kartlastet"
      v-show="activeGeographicFilterMode === geographicFilterOptions[3]"
      :kartview="mapViewObject"
      :bufferlayer="bufferlayer"
    ></map-buffer>
    <div class="map-supporting-layers-toggle-div">
      <map-supporting-layer-list v-if="kartlastet" :map-object="mapObject" />
    </div>
    <map-search
      class="map-search"
      v-if="kartlastet"
      :kartview="mapViewObject"
    ></map-search>

    <map-popup
      v-if="kartlastet"
      :kartview="mapViewObject"
      :selectionlayer="selectionlayer"
      :tidsrom="this.tidsrom"
    ></map-popup>
    <map-tooltip
      v-if="kartlastet"
      :kartview="mapViewObject"
      :selectionlayer="selectionlayer"
      :tidsrom="this.tidsrom"
    ></map-tooltip>
    <!-- <div > -->
    <map-basemap-toggle
      class="map-basemap-toggle-div"
      v-if="kartlastet"
      @basemap-changed="setBasemap"
      :basemaps="kart.basemaps"
    ></map-basemap-toggle>
    <!-- </div> -->
    <map-legend v-show="showStationsFromOtherActors" class="map-legend" />
    <div
      v-if="kartlastet"
      class="elevation-2"
      style="position: absolute; background: white;
  right: 10px;
  bottom: 50px; width: 40px; border-radius: 4px"
    >
      <map-zoom-navigation :map-view="this.mapViewObject" />
      <v-divider />
      <map-locate-button :kartview="mapViewObject" />
      <v-divider />
      <map-reset-extent-button :kartview="mapViewObject" />
    </div>

    <v-footer absolute class="elevation-2">
      <span class="pl-1 pr-2 pb-1 pt-1 text-caption " style="">
        Kartverket, Geovekst og kommuner - Geodata AS | NVEs kartdata
        distribueres i henhold til
        <a
          style="color: blue"
          rel="noopener"
          href="https://data.norge.no/nlod/no"
          ><u>Norsk lisens for offentlige data</u></a
        >.
      </span>
      <div id="scaleBar"></div>
      <v-spacer />
      <map-loading-bar v-if="kartlastet" :map-view-object="mapViewObject" />
    </v-footer>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import {
  MapDrawing,
  MapBuffer,
  MapSearch,
  MapPopup,
  MapTooltip,
  MapLoadingBar,
  MapBasemapToggle,
  MapGeographicFilter,
} from "@/components/index";
import MapService from "../../services/MapService";
import MapLegend from "./Tools/MapLegend.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "TheMap",
  props: {
    size: Number,
  },
  components: {
    MapDrawing,
    MapBuffer,
    MapSearch,
    MapPopup,
    MapBasemapToggle,
    MapTooltip,
    MapLoadingBar,
    MapGeographicFilter,
    MapZoomNavigation: () => import("@/components/Map/Tools/MapZoomNavigation"),
    MapResetExtentButton: () =>
      import("@/components/Map/Tools/MapResetExtentButton"),
    MapLocateButton: () => import("@/components/Map/Tools/MapLocateButton"),
    MapSupportingLayerList: () =>
      import("@/components/Map/Tools/MapSupportingLayerList"),
    MapLegend,
  },
  data() {
    return {
      tegnelag: Object,
      bufferlayer: Object,
      selectionlayer: Object,
      hovedlag: Object,
      operationalLayers: [],
      kartlastet: false,
      tidsrom: Array,
      ekskluderteTidsserier: [],
      loadedBasemaps: [],
      stationsFromOtherActorsLayer: null,
    };
  },
  computed: {
    ...mapState([
      "searchUrl",
      "kart",
      "queryExpression",
      "activeGeographicFilterMode",
      "geographicFilterOptions",
      "showStationsFromOtherActors",
      "queryExpressionStationsFromOtherActors",
      "mainLayerSymbolSettings",
    ]),
    mapHasLoaded: {
      get() {
        return this.$store.state.mapHasLoaded;
      },
      set(newValue) {
        return this.$store.dispatch("setMapHasLoaded", newValue);
      },
    },
  },
  methods: {
    ...mapActions(["setCurrentMapExtent", "setSelectedBasemap"]),
    toggleStationsFromOtherActorsLayer: function() {
      this.stationsFromOtherActorsLayer.visible = !this
        .stationsFromOtherActorsLayer.visible;
    },
    setBasemap(basemap) {
      this.mapObject.basemap = this.loadedBasemaps.find(
        (loadedBasemap) => loadedBasemap.id === basemap.id
      );
    },
    updateMainLayerSymbol: function(symbolSettings) {
      loadModules(["esri/renderers/SimpleRenderer"]).then(
        ([SimpleRenderer]) => {
          if (
            symbolSettings.color === "#448eff" &&
            symbolSettings.size.text === "Normal"
          ) {
            this.hovedlag.sublayers.items[0].renderer = null;
            this.hovedlag.sublayers.items[0].labelingInfo = this.kart.mainLayerArcGISOptions.sublayers[0].labelingInfo;
          } else {
            this.hovedlag.sublayers.items[0].renderer = new SimpleRenderer({
              symbol: {
                type: "simple-marker",
                color: symbolSettings.color,
                outline: {
                  color: [0, 0, 0, 0.7],
                  width: 1,
                },
                size: symbolSettings.size.value,
              },
            });
            this.hovedlag.sublayers.items[0].labelingInfo[0].symbol.yoffset =
              symbolSettings.size.yOffset;
            this.hovedlag.sublayers.items[0].labelingInfo[0].symbol.font.size =
              symbolSettings.size.labelSize;
          }
        }
      );
    },
    getAndSetExtent: function() {
      this.kartlastet = true;
      let extent;
      if (this.mapViewObject.extent) {
        if (
          this.tegnelag.graphics.length > 0 &&
          this.activeGeographicFilterMode === "Avgrens med polygon"
        ) {
          extent = this.tegnelag.graphics.items[0].geometry;
        } else {
          extent = this.mapViewObject.extent;
        }
        this.setCurrentMapExtent(extent.toJSON());
      }
    },
    oppdaterKartFiltrering: function(queryExpression) {
      this.hovedlag.findSublayerById(0).definitionExpression = queryExpression;
    },
    updateStationsFromOtherActorsLayerFilter: function(queryExpression) {
      this.stationsFromOtherActorsLayer.findSublayerById(
        0
      ).definitionExpression = queryExpression;
    },
    addScalebar: function() {
      loadModules(["esri/widgets/ScaleBar"]).then(([ScaleBar]) => {
        new ScaleBar({
          view: this.mapViewObject,
          unit: "metric",
          container: "scaleBar",
        });
      });
    },
  },
  watch: {
    queryExpression: function(newQueryExpression, oldQueryExpression) {
      if (newQueryExpression != oldQueryExpression) {
        this.oppdaterKartFiltrering(newQueryExpression);
      }
    },
    queryExpressionStationsFromOtherActors: function(
      newQueryExpression,
      oldQueryExpression
    ) {
      if (newQueryExpression != oldQueryExpression) {
        this.updateStationsFromOtherActorsLayerFilter(newQueryExpression);
      }
    },
    showStationsFromOtherActors: function() {
      this.toggleStationsFromOtherActorsLayer();
    },
    activeGeographicFilterMode: function() {
      this.getAndSetExtent();
    },
    mainLayerSymbolSettings: {
      handler(newVal) {
        this.updateMainLayerSymbol(newVal);
      },
      deep: true,
    },
  },
  mounted: function() {
    loadModules([
      "esri/Map",
      "esri/views/MapView",
      "esri/layers/MapImageLayer",
      "esri/core/watchUtils",
      "esri/layers/GraphicsLayer",
    ])
      .then(([Map, MapView, MapImageLayer, watchUtils, GraphicsLayer]) => {
        MapService.loadBasemaps(this.kart.basemaps).then((loadedBasemaps) => {
          this.loadedBasemaps = loadedBasemaps;
          // Bygger opp kartlag fra config
          this.kart.kartlag.forEach((kartlagDefinisjon) => {
            let kartlag = new MapImageLayer(kartlagDefinisjon);
            this.operationalLayers.push(kartlag);
          });

          this.stationsFromOtherActorsLayer = new MapImageLayer(
            this.kart.timeSeriesOtherActorsLayer
          );
          this.operationalLayers.push(this.stationsFromOtherActorsLayer);

          // Legger til hovedkartlag
          this.hovedlag = new MapImageLayer(this.kart.mainLayerArcGISOptions);
          this.operationalLayers.push(this.hovedlag);

          // Legger til tegnelag
          this.tegnelag = new GraphicsLayer({
            listMode: "hide",
            id: "tegnelag",
            title: "Tegnelag",
          });
          this.operationalLayers.push(this.tegnelag);

          // Legger til bufferlayer
          this.bufferlayer = new GraphicsLayer({
            listMode: "hide",
          });
          this.operationalLayers.push(this.bufferlayer);

          // Legger til selekteringslag
          this.selectionlayer = new GraphicsLayer();
          this.operationalLayers.push(this.selectionlayer);

          // Opprett kart
          this.mapObject = new Map({
            basemap: this.loadedBasemaps[0],
            layers: this.operationalLayers,
          });

          this.setSelectedBasemap(this.kart.basemaps[0]);

          // Opprett kartview
          this.mapViewObject = new MapView({
            container: "map",
            map: this.mapObject,
            ...this.kart.mapViewStartupSettings,
          });

          watchUtils.whenFalse(this.mapViewObject, "updating", () => {
            this.mapHasLoaded = true;
          });

          this.mapViewObject.ui._removeComponents(["attribution", "zoom"]);

          this.addScalebar();

          watchUtils.whenTrue(
            this.mapViewObject,
            "stationary",
            function() {
              this.getAndSetExtent();
            }.bind(this)
          );

          // Stygg hack - finn ut hvordan man kan slå av default graphicslayer i mapview
          setTimeout(() => {
            this.mapObject.layers.items[
              this.mapObject.layers.items.length - 1
            ].listMode = "hide";
          }, 2000);
        });
      })
      .catch((err) => {
        // eslint-disable-next-line
        console.error(err);
      });
  },
};
</script>
<style>
.map-container {
  min-height: 100%;
  height: 100%;
  width: auto;
}
.map {
  height: 100%;
  width: auto;
}

.esri-ui-corner-container {
  bottom: 15px !important;
  top: 6px !important;
}

/* *:focus {
  outline: none !important;
} */

.vue-content-placeholders-img {
  height: 650px !important;
}

.esri-component.esri-attribution.esri-widget {
  display: none;
}

.tegning {
  margin-left: 10px;
  top: 70px;
}

.map-search {
  right: 10px;
  top: 10px;
  position: absolute;
}

.map-loading {
  right: 100px;
  top: 100px;
  position: absolute;
}

.buffer {
  margin-left: 10px;
  top: 70px;
}

.collapsing {
  -webkit-transition: none;
  transition: none;
  display: none;
}

.map-dropdown-menu {
  margin-top: -20px !important;
}

.esri-widget--button {
  height: 45px !important;
  width: 45px !important;
}

.map-basemap-toggle-div {
  position: absolute;
  left: 15px;
  bottom: 50px;
}

.map-legend {
  position: absolute;
  left: 15px;
  bottom: 120px;
}

.map-supporting-layers-toggle-div {
  position: absolute;
  left: 270px;
  top: 12px;
}

.esri-legend__message {
  display: none;
}

table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  text-align: left;
  padding: 8px;
}

.esri-view .esri-view-surface:focus::after {
  outline: #fd0 solid 10px;
}

div.esri-view-surface.esri-view-surface--touch-none:focus::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  outline: auto 2px Highlight;
  outline: auto 5px -webkit-focus-ring-color;
  outline-offset: -3px;
  pointer-events: none;
  overflow: hidden;
}
</style>
